import { render, staticRenderFns } from "./ModalConfirmConcent.vue?vue&type=template&id=75fb5885&scoped=true"
import script from "./ModalConfirmConcent.vue?vue&type=script&lang=js"
export * from "./ModalConfirmConcent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb5885",
  null
  
)

export default component.exports